import { render, staticRenderFns } from "./DocumentTableBox.vue?vue&type=template&id=5fec5b49&scoped=true"
import script from "./DocumentTableBox.vue?vue&type=script&lang=ts"
export * from "./DocumentTableBox.vue?vue&type=script&lang=ts"
import style0 from "./DocumentTableBox.vue?vue&type=style&index=0&id=5fec5b49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fec5b49",
  null
  
)

export default component.exports